import React from 'react';
import {AllLocations_Location} from "../../sdk/queries";
import {ParticulateMatter10Filter, ReducedParticulateMatter10Filter} from "../../sdk/queries/types";


export interface DateRange {
    fromDate: number;
    toDate: number;
}

export interface Measurements {
    avg: number;
    min: number;
    max: number;
}

export interface Loading {
    filters: boolean;
    locations: boolean;
}

export interface IAQMContext {
    currentRange: DateRange;
    data: ReducedParticulateMatter10Filter[];
    measurements: Measurements;
    loading: Loading;
    locations: AllLocations_Location[];
    currentLocation: AllLocations_Location | undefined;
    fetchReport(locationId: number, middleDate: number): void;
}


export const AQMContext = React.createContext<IAQMContext>(
// @ts-ignore
    {}
);

export const useAQM = () => React.useContext(AQMContext);